import { useMemo } from 'react';
import { Outlet, useResolvedPath } from 'react-router-dom';

import { Breadcrumb } from '../../../components/Breadcrumb';
import { PageHeader } from '../../../components/PageHeader';
import { ITabItem, TabBar } from '../../../components/tabs/Tabs';
import { ErrorStateBoundary } from '../../../components/error-state/ErrorStateBoundary';
import { EmailType, DocumentType } from 'src/types/enums';
import { AllGeneralSettingsProvider } from '../all-settings-context';
import { PageHeading } from 'components/PageHeading';

const SettingsPage = () => {
  const generalSettingsRoute = useResolvedPath('general');
  const customerRoute = useResolvedPath('customer');
  const actionsRoute = useResolvedPath('actions');
  const orderSettingsRoute = useResolvedPath('order');
  const invoiceSettingsRoute = useResolvedPath('invoice');
  const emailSettingsRoute = useResolvedPath(`email/${EmailType.Invoice}`);
  const documentSettingsRoute = useResolvedPath(`document/${DocumentType.Tro}`);
  const mailboxSettingsRoute = useResolvedPath('mailbox');
  const usersSettingsRoute = useResolvedPath('users');
  const carrierInformationSettingsRoute = useResolvedPath('carrier-information');

  const tabItems = useMemo<ITabItem[]>(() => {
    return [
      {
        title: 'Algemeen',
        path: generalSettingsRoute.pathname,
      },
      {
        title: 'Klanten',
        path: customerRoute.pathname,
      },
      {
        title: 'Vervoerders',
        path: carrierInformationSettingsRoute.pathname,
      },
      {
        title: 'Acties',
        path: actionsRoute.pathname,
      },
      {
        title: 'Order',
        path: orderSettingsRoute.pathname,
      },
      {
        title: 'Facturatie',
        path: invoiceSettingsRoute.pathname,
      },
      {
        title: 'Email',
        path: emailSettingsRoute.pathname,
      },
      {
        title: 'Document',
        path: documentSettingsRoute.pathname,
      },
      {
        title: 'Mailbox',
        path: mailboxSettingsRoute.pathname,
      },
      {
        title: 'Gebruikers',
        path: usersSettingsRoute.pathname,
      },
    ];
  }, []);

  return (
    <>
      <PageHeader title="Instellingen" />

      <PageHeading noMarginBottom leftSide={<Breadcrumb currentItem="Instellingen" />} />

      <div className="shrink-0 bg-surface px-6">
        <TabBar items={tabItems} />
      </div>

      <div className="p-7">
        <AllGeneralSettingsProvider>
          <ErrorStateBoundary variant="section">
            <Outlet />
          </ErrorStateBoundary>
        </AllGeneralSettingsProvider>
      </div>
    </>
  );
};

export default SettingsPage;
